export const BASE_HEADERS = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'x-api-key': process.env.STD__X_API_KEY,
};
